var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("formFormat", {
        attrs: {
          page: _vm.page,
          formInput: _vm.formInput,
          loading: _vm.loading,
          error: _vm.errorMessage,
          checkPolicy: _vm.checkPrivacyPolicy,
          "data-test": "formFormat",
        },
        on: {
          "update:error": function ($event) {
            _vm.errorMessage = $event
          },
          submit: _vm.showEmitValue,
        },
      }),
      _c(
        "b-modal",
        {
          attrs: {
            id: "registerSuccess",
            "no-close-on-backdrop": "",
            "no-close-on-esc": "",
            centered: "",
            title: _vm.$t("modal.success"),
          },
          scopedSlots: _vm._u([
            {
              key: "modal-header",
              fn: function () {
                return [
                  _c("h5", [_vm._v(_vm._s(_vm.$t("modal.success")))]),
                  _c("button", { on: { click: _vm.fnAfterRegister } }, [
                    _vm._v("X"),
                  ]),
                ]
              },
              proxy: true,
            },
            {
              key: "modal-footer",
              fn: function ({ ok }) {
                return [
                  _c(
                    "m-button",
                    {
                      staticClass: "tableButton cancel",
                      attrs: { raised: "", dense: "" },
                      on: {
                        click: function ($event) {
                          ok(_vm.fnAfterRegister())
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("button.ok")) + " ")]
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c("h6", [
            _vm._v(_vm._s(_vm.$t("modal.registerUser.success.text1"))),
          ]),
          _c("h6", [
            _vm._v(_vm._s(_vm.$t("modal.registerUser.success.text2"))),
          ]),
          _c("h6", [
            _vm._v(_vm._s(_vm.$t("modal.registerUser.success.text3"))),
          ]),
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            id: "registerError",
            centered: "",
            title: _vm.$t("modal.error"),
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function ({ close }) {
                return [
                  _c(
                    "m-button",
                    {
                      staticClass: "tableButton cancel",
                      attrs: { raised: "", dense: "" },
                      on: {
                        click: function ($event) {
                          return close()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("button.ok")) + " ")]
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c("h6", [_vm._v(_vm._s(_vm.$t("modal.registerUser.error.text1")))]),
          _c("h6", [_vm._v(_vm._s(_vm.$t("modal.registerUser.error.text2")))]),
          _c("h6", [_vm._v(_vm._s(_vm.$t("modal.registerUser.error.text3")))]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }